export const CODE_LENGTH = 6;
export const NUM_OF_TRIES = 5;
export const NUM_OF_AVATARS = 24;
export const NUM_OF_SHUFFLE = 3;
export const ROUND_TIMER_TIME_IN_SECONDS = 180;
export const HAND_LENGTH = 7;
export const MIN_NUM_OF_PLAYERS = 4;
export const MAX_NUM_OF_PLAYERS = 8;
export const MAX_SCORE = 5;
export const ROUND_WINNER_PAGE_DURATION_IN_SECONDS = 10;
export const END_EXIT_GAME_NOTIFICATION_DIALOG_DURATION_IN_SECONDS = 5;
export const WAIT_DURATION_TO_OPEN_RED_CARD_IN_SECONDS = 5;
export const SHOULD_SHOW_HAND_DURATION_IN_SECONDS = 2;
export const SHOULD_SHOW_SKIP_CARD_DURATION_IN_SECONDS = 2;
export const WAIT_DURATION_TO_DRAW_BLACK_CARDS_IN_SECONDS = 2;
export const WAIT_DURATION_TO_PLAY_IN_SECONDS = 3;
export const RED_COLOR_SHADE = 0xFFD30000;
export const GREY_COLOR_SHADE = 0xFFD3D3D3;

export const disclaimerText1 = "Justly is a fictional game for entertainment only. The cards in the game are jokes and are not meant to be taken seriously or acted upon.";
export const disclaimerText2 = "Players should never attempt or encourage real-world actions based on the game.";

export const kickstarterUrl = "https://www.kickstarter.com/projects/audreybrown/justly-the-party-game-where-karma-strikes-back";
export const howToPlayUrl = "https://youtu.be/dQpVChnpT5c?feature=shared";
export const instagramUrl = "https://www.instagram.com/justlycardgame?igsh=MWZkcGlkeGR3NnhhaQ%3D%3D&utm_source=qr";
export const youtubeUrl = "https://youtube.com/@hahaentertainment-f5g?feature=shared";
export const tiktokUrl = "https://www.tiktok.com/@justlycardgame?_t=ZT-8vxNfhsXUfC&_r=1";

export const etsyLink = "https://www.etsy.com/listing/4348295832/justly-card-game";
export const amazonLink = "https://www.amazon.com/dp/B0H9L2CYHQ";